import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Log } from 'src/app/models/log';
import { Service, ServiceMethods } from '@feathersjs/feathers';
import { TableColumn, VznDataTableComponent } from '@noammazuz/vzn-data-table';
import { VznFeathersService, AuthService } from '@noammazuz/vzn-feathers';
import { Site } from 'src/app/models/site';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { Email } from 'src/app/models/email';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-log-table',
  templateUrl: './log-table.component.html',
  styleUrls: ['./log-table.component.scss']
})
export class LogTableComponent implements OnInit {
  @ViewChild('table') table: VznDataTableComponent;
  logService: ServiceMethods<Log>;
  siteService: ServiceMethods<any>;
  maillistService: ServiceMethods<any>;
  emailService: ServiceMethods<any>;
  actionService: ServiceMethods<any>;
  query: any = {
    $populate: ['site'],
    $sort: {
      createdAt: -1
    }
  };
  columns: TableColumn[];
  emailList: Email[];
  emailToDelete: FormControl = new FormControl();

  constructor(public translate: TranslateService,
    private feathers: VznFeathersService<Log>,
    private http: HttpClient,
    private authService: AuthService<any>,
    private dialog: MatDialog,
      ) {
        this.translate=translate;
    this.logService = this.feathers.service('logs');
    this.siteService = this.feathers.service('sites');
    this.maillistService = this.feathers.service('maillists');
    this.emailService = this.feathers.service('emails');
    this.actionService = this.feathers.service('actions');
  }

  ngOnInit(): void {
    this.columns = [
      { prop: 'createdAt', name: this.translate.instant("LOG-TABLE.TIME"), filterType: 'date', cellTemplate: 'dateTmpl'},
      {
        prop: 'action', name: this.translate.instant("LOG-TABLE.ACTION"), cellTemplate: 'textTmpl', filterType: 'options', options: [
        { viewValue: 'VIEW', value: 'VIEW' },
        { viewValue: 'LOGIN_FAILED', value: 'LOGIN_FAILED' },
        { viewValue: 'LOGIN', value: 'LOGIN' }
      ]},
      { prop: 'userName', name: this.translate.instant("LOG-TABLE.EMAIL"), filterType: 'like', cellTemplate: 'textTmpl'},
      { prop: 'password', name: this.translate.instant("LOG-TABLE.PASSWORD"), filterType: 'like', cellTemplate: 'textTmpl'},
      { prop: 'contact.email', filterProp: 'contactId', name: this.translate.instant("LOG-TABLE.CONTACT"), filterType: 'like', cellTemplate: 'textTmpl'},
      { prop: 'contact.company', filterProp: 'contactId', name: this.translate.instant("LOG-TABLE.COMPANY"), filterType: 'like', cellTemplate: 'textTmpl'},
      { prop: 'contact.department', filterProp: 'contactId', name: this.translate.instant("LOG-TABLE.CLASS"), filterType: 'like', cellTemplate: 'textTmpl'},
      {
        prop: 'site.name', filterProp: 'siteId', name: this.translate.instant("LOG-TABLE.SITE"), cellTemplate: 'textTmpl',
        filterType: 'options',
        options: {
          service: this.siteService,
          fieldName: 'name'
        }
      },
      {
        prop: 'maillist.name', filterProp: 'maillistId', name: this.translate.instant("LOG-TABLE.MAILING-LIST"), cellTemplate: 'textTmpl',
        filterType: 'options',
        options: {
          service: this.maillistService,
          fieldName: 'name'
        }
      },
      {
        prop: 'email.name', filterProp: 'emailId', name: this.translate.instant("LOG-TABLE.MAILING"), cellTemplate: 'textTmpl',
        filterType: 'options',
        options: {
          service: this.emailService,
          fieldName: 'name'
        }
      },
    ];
    this.loadEmailList();
  }

  async loadEmailList() {
    const res = await this.emailService.find({ $limit: 999 });
    this.emailList = res?.data;
  }

  logMapper(rows: any[]) {
    return rows.map(row => new Log(row));
  }

  emailDisplay(email: Email) {
    return email?.name;
  }

  async deleteEmailLogs() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      direction: this.translate.currentLang === 'he' ? 'rtl' :'ltr',
      data: {
        title: this.translate.instant('LOG-TABLE.DELETE_CONFIRMATION_TITLE'),
        body: this.translate.instant('LOG-TABLE.DELETE_CONFIRMATION_BODY')
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    if (res) {
      await this.actionService.create({
        cmd: "delete-logs",
        params: {
          emailId: this.emailToDelete.value._id
        }
      });
      this.query = { ...this.query };
      this.table.setTableData();
    }
  }
}
